import axios from "axios";
import { useEffect, useState } from "react";
// import { alertify, alertifyNew } from "../helperFunctions";
import { LocalStorage } from "../services";

const csrftoken = getCSRFToken();

const axiosIns = axios.create({
    baseURL: process.env.REACT_APP_LAYER_URL,
    withCredentials: true,
    headers: {
        'X-CSRFToken': csrftoken
    },
});


const AuthFailContent = () => {
    const [timeLeft, setTimeLeft] = useState(5);

    useEffect(() => {
        const timeInterval = setInterval(() => setTimeLeft((prev) => prev - 1), 1000);

        return () => {
            clearInterval(timeInterval);
        };
    }, []);

    return (
        <p>
            Authentication Failed!
            <br /> {`You will be redirected to Login Page in ${timeLeft} second${timeLeft < 2 ? "" : "s"}..`}
        </p>
    );
};

axiosIns.interceptors.request.use(
    function (config) {
        if (config.method.toLowerCase() === "get" || config.method.toLowerCase() === "delete") {
        } else if (config.method.toLowerCase() === "post" || config.method.toLowerCase() === "put") {
            if (typeof config.data === "object" && config.headers.getContentType() !== "multipart/form-data") {
                let data = JSON.parse(
                    JSON.stringify(config.data, (key, value) => (typeof value === "undefined" ? null : value)),
                );
                config.data = data;
            }
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    },
);

axiosIns.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (error?.response?.status === 503) {
            // alertify(
            //     "Service Unavailable!",
            //     "Services are unavailable at the moment. Please try again after some time. We appreciate your patience.",
            //     "error",
            //     { hideFooter: true },
            // );
        } else if (error?.response?.status === 401) {
            let redirect_url = `${process.env.REACT_APP_BASE_URL}`;
            let message = "Seems like you are not logged in. You will be redirected to Login Page in 5 seconds...";

            if (error.response.data instanceof Blob) {
                var reader = new FileReader();
                reader.onload = function () {
                    let data = JSON.parse(reader.result);
                    redirect_url = data.login_url;
                    message = data.message || message;
                };
                reader.readAsText(error.response.data);
            }

            LocalStorage.removeAll();
            // alertifyNew({
            //     message: <AuthFailContent />,
            //     type: "error",
            //     autoClose: true,
            //     autoCloseTime: 5,
            // });

            setTimeout(() => {
                window.location.replace(redirect_url);
            }, 5000);
        }

        return Promise.reject(error);
    },
);

function getCSRFToken() {
    const cookieValue = document.cookie
        .split('; ')
        .find(row => row.startsWith('csrftoken='));

    if (cookieValue) {
        return cookieValue.split('=')[1];
    } else {
        console.error('CSRF token not found in cookies.');
        return null;
    }
}

export { axiosIns };
